<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">ইমেজ আপলোড</h1>
        <p class="page-subtitle bangla-text">ইমেজ আপলোড করুন এবং পরিচালনা করুন</p>
      </div>
      <div class="page-stats">
        <div class="stat-item">
          <span class="stat-number">{{ allImages.length }}</span>
          <span class="stat-label bangla-text">মোট ইমেজ</span>
        </div>
        <div class="stat-item" *ngIf="filteredImages.length !== allImages.length">
          <span class="stat-number">{{ filteredImages.length }}</span>
          <span class="stat-label bangla-text">ফিল্টারড</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-cloud-upload-alt"></i>
        নতুন ইমেজ আপলোড
      </h3>
      <div class="upload-status" *ngIf="uploadStatus">
        <span class="status-badge" [class]="getStatusClass()">
          <i class="fas" [class]="getStatusIcon()"></i>
          {{ uploadStatus }}
        </span>
      </div>
    </div>
    
    <div class="card-body">
      <form class="modern-form">
        <div class="upload-section">
          <div class="form-group">
            <label class="form-label bangla-label">ইমেজ ফাইল নির্বাচন করুন</label>
            <div class="file-input-wrapper">
              <label for="imageFile" class="file-input-label">
                <div class="upload-area">
                  <div class="upload-icon">
                    <i class="fas fa-cloud-upload-alt"></i>
                  </div>
                  <div class="upload-text">
                    <h4 class="bangla-text">ইমেজ নির্বাচন করুন</h4>
                    <p class="bangla-text">ক্লিক করুন বা ফাইল টেনে আনুন</p>
                  </div>
                </div>
                <input 
                  type="file" 
                  id="imageFile" 
                  class="file-input" 
                  (change)="onFileSelected($event)" 
                  accept="image/*">
              </label>
            </div>
            
            <div class="file-info" *ngIf="selectedFile">
              <div class="selected-file-card">
                <div class="file-preview" *ngIf="filePreviewUrl">
                  <img [src]="filePreviewUrl" alt="Preview">
                </div>
                <div class="file-details">
                  <h5 class="file-name bangla-text">{{ selectedFile.name }}</h5>
                  <div class="file-meta">
                    <span class="file-size">{{ getFileSize(selectedFile.size) }}</span>
                    <span class="file-type">{{ selectedFile.type }}</span>
                  </div>
                  <div class="validation-status" [class]="getValidationClass()">
                    <i class="fas" [class]="getValidationIcon()"></i>
                    <span class="bangla-text">{{ getValidationMessage() }}</span>
                  </div>
                </div>
                <button type="button" class="btn-action-sm btn-delete" (click)="clearSelectedFile()" title="ফাইল সরান">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          
          <div class="upload-guidelines-card">
            <h5 class="guidelines-title bangla-label">আপলোড নির্দেশনা</h5>
            <ul class="guidelines-list bangla-text">
              <li><i class="fas fa-check"></i> সমর্থিত ফরম্যাট: JPG, PNG, GIF, SVG, BMP</li>
              <li><i class="fas fa-check"></i> সর্বোচ্চ ফাইল সাইজ: ২০ মেগাবাইট</li>
              <li><i class="fas fa-exclamation-triangle"></i> একই নামের ফাইল পূর্বের ফাইল প্রতিস্থাপন করবে</li>
              <li><i class="fas fa-info-circle"></i> ইমেজ সরাসরি পাবলিক ডিরেক্টরিতে সংরক্ষিত হবে</li>
            </ul>
          </div>
        </div>
        
        <div class="form-actions" *ngIf="selectedFile">
          <button 
            type="button"
            class="btn-secondary-modern bangla-text" 
            (click)="clearSelectedFile()">
            <i class="fas fa-times"></i>
            বাতিল
          </button>
          <button 
            type="button"
            class="btn-primary-modern bangla-text" 
            [disabled]="!selectedFile || isUploading || !isFileValid" 
            (click)="uploadImage()">
            <span *ngIf="isUploading" class="loading-spinner">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            <i class="fas fa-upload" *ngIf="!isUploading"></i>
            {{ isUploading ? 'আপলোড হচ্ছে...' : 'ইমেজ আপলোড করুন' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Recent Upload Result -->
  <div class="content-card slide-up success-card" *ngIf="uploadedImageUrl">
    <div class="card-header success">
      <h3 class="card-title bangla-title">
        <i class="fas fa-check-circle"></i>
        সফলভাবে আপলোড হয়েছে
      </h3>
      <div class="upload-timestamp" *ngIf="uploadTimestamp">
        <span class="timestamp-label bangla-text">আপলোড সময়:</span>
        <span class="timestamp-value">{{ uploadTimestamp | date:'dd/MM/yyyy hh:mm a' }}</span>
      </div>
    </div>
    
    <div class="card-body">
      <div class="uploaded-result">
        <div class="result-preview">
          <div class="image-container">
            <img [src]="uploadedImageUrl" alt="Uploaded image" class="uploaded-image" (load)="onUploadedImageLoad($event)">
            <div class="image-overlay">
              <button type="button" class="btn-action-overlay" (click)="viewImage(uploadedImageUrl)" title="পূর্ণ আকারে দেখুন">
                <i class="fas fa-expand-alt"></i>
              </button>
            </div>
          </div>
          <div class="success-badge">
            <i class="fas fa-check"></i>
            <span class="bangla-text">সম্পন্ন</span>
          </div>
        </div>
        
        <div class="result-details">
          <div class="image-info-header">
            <h5 class="bangla-text">আপলোড সম্পন্ন</h5>
            <div class="success-indicator">
              <span class="success-dot"></span>
              <span class="bangla-text">সক্রিয়</span>
            </div>
          </div>

          <!-- Image Metadata -->
          <div class="image-metadata">
            <div class="metadata-grid">
              <div class="metadata-item">
                <span class="metadata-label bangla-text">ফাইলের নাম:</span>
                <span class="metadata-value">{{ getUploadedImageName() }}</span>
              </div>
              <div class="metadata-item" *ngIf="uploadedImageSize">
                <span class="metadata-label bangla-text">ফাইল সাইজ:</span>
                <span class="metadata-value">{{ uploadedImageSize }}</span>
              </div>
              <div class="metadata-item" *ngIf="uploadedImageDimensions">
                <span class="metadata-label bangla-text">রেজোলিউশন:</span>
                <span class="metadata-value">{{ uploadedImageDimensions }}</span>
              </div>
              <div class="metadata-item">
                <span class="metadata-label bangla-text">ফরম্যাট:</span>
                <span class="metadata-value">{{ getUploadedImageFormat() }}</span>
              </div>
            </div>
          </div>

          <!-- URL Section -->
          <div class="form-group">
            <label class="form-label bangla-label">
              <i class="fas fa-link"></i>
              ইমেজ URL:
            </label>
            <div class="url-container">
              <input type="text" [value]="uploadedImageUrl" readonly class="form-control-modern url-input">
              <button type="button" class="btn-action-sm btn-copy" (click)="copyImageUrl(uploadedImageUrl)" title="URL কপি করুন">
                <i class="fas fa-copy"></i>
              </button>
            </div>
            <div class="url-helper-text bangla-text">
              <i class="fas fa-info-circle"></i>
              এই URL টি আপনার প্রোজেক্টে ব্যবহার করতে পারেন
            </div>
          </div>

          <!-- Quick Actions -->
          <div class="quick-actions">
            <h6 class="actions-title bangla-text">দ্রুত কার্যক্রম</h6>
            <div class="actions-grid">
              <button type="button" class="action-item-btn" (click)="viewImage(uploadedImageUrl)" title="পূর্ণ আকারে দেখুন">
                <i class="fas fa-eye"></i>
                <span class="bangla-text">দেখুন</span>
              </button>
              
              <button type="button" class="action-item-btn" (click)="copyImageUrl(uploadedImageUrl)" title="URL কপি করুন">
                <i class="fas fa-copy"></i>
                <span class="bangla-text">কপি</span>
              </button>
              
              <a [href]="uploadedImageUrl" target="_blank" class="action-item-btn" title="নতুন ট্যাবে খুলুন">
                <i class="fas fa-external-link-alt"></i>
                <span class="bangla-text">খুলুন</span>
              </a>
              
              <a [href]="uploadedImageUrl" [download]="getUploadedImageName()" class="action-item-btn" title="ডাউনলোড করুন">
                <i class="fas fa-download"></i>
                <span class="bangla-text">ডাউনলোড</span>
              </a>
              
              <button type="button" class="action-item-btn action-delete" (click)="deleteUploadedImage()" title="ডিলিট করুন">
                <i class="fas fa-trash"></i>
                <span class="bangla-text">ডিলিট</span>
              </button>
            </div>
          </div>

          <!-- Share Section -->
          <div class="share-section">
            <h6 class="share-title bangla-text">শেয়ার করুন</h6>
            <div class="share-options">
              <button type="button" class="share-btn" (click)="shareImage('link')" title="লিংক শেয়ার করুন">
                <i class="fas fa-link"></i>
                <span class="bangla-text">লিংক</span>
              </button>
              
              <button type="button" class="share-btn" (click)="shareImage('embed')" title="এম্বেড কোড">
                <i class="fas fa-code"></i>
                <span class="bangla-text">এম্বেড</span>
              </button>
              
              <button type="button" class="share-btn" (click)="shareImage('html')" title="HTML কোড">
                <i class="fab fa-html5"></i>
                <span class="bangla-text">HTML</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <!-- Filters and Actions Section -->
  <div class="content-card slide-up" *ngIf="!isLoadingImages">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-filter"></i>
        ফিল্টার এবং অ্যাকশন
      </h3>
    </div>
    
    <div class="card-body">
      <!-- Filter Controls -->
      <div class="filters-section">
        <div class="filter-row">
          <div class="filter-group">
            <label class="filter-label bangla-label">অনুসন্ধান:</label>
            <div class="search-container">
              <input 
                type="text" 
                class="form-control-modern" 
                placeholder="ইমেজ খুঁজুন..." 
                [(ngModel)]="searchTerm"
                (input)="filterImages()">
              <i class="fas fa-search search-icon"></i>
              <button 
                type="button" 
                class="clear-search-btn" 
                *ngIf="searchTerm" 
                (click)="clearSearch()"
                title="খোঁজ পরিষ্কার করুন">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <div class="filter-group">
            <label class="filter-label bangla-label">ধরণ ফিল্টার:</label>
            <select 
              class="form-control-modern" 
              [(ngModel)]="imageFilter" 
              (change)="applyFilter()">
              <option value="all">সব ইমেজ</option>
              <option value="recent">সাম্প্রতিক</option>
              <option value="jpg">JPG</option>
              <option value="png">PNG</option>
              <option value="gif">GIF</option>
              <option value="svg">SVG</option>
              <option value="bmp">BMP</option>
            </select>
          </div>

          <div class="filter-group">
            <label class="filter-label bangla-label">সাজানো:</label>
            <select 
              class="form-control-modern" 
              [(ngModel)]="sortOption" 
              (change)="sortImages()">
              <option value="name-asc">নাম (ক-ও)</option>
              <option value="name-desc">নাম (ও-ক)</option>
              <option value="date-newest">নতুন প্রথম</option>
              <option value="date-oldest">পুরাতন প্রথম</option>
            </select>
          </div>
          
          <div class="filter-group">
            <label class="filter-label bangla-label">দেখার ধরণ:</label>
            <div class="view-toggle">
              <button 
                type="button"
                class="view-btn" 
                [class.active]="galleryView === 'grid'"
                (click)="setGalleryView('grid')"
                title="গ্রিড ভিউ">
                <i class="fas fa-th"></i>
              </button>
              <button 
                type="button"
                class="view-btn" 
                [class.active]="galleryView === 'list'"
                (click)="setGalleryView('list')"
                title="লিস্ট ভিউ">
                <i class="fas fa-list"></i>
              </button>
            </div>
          </div>

          <div class="filter-group">
            <button class="btn-outline-modern" (click)="clearFilters()">
              <i class="fas fa-times"></i>
              ফিল্টার সাফ করুন
            </button>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons" *ngIf="selectedImages.length > 0">
        <button 
          type="button"
          class="btn-secondary-modern" 
          (click)="bulkCopyUrls()">
          <i class="fas fa-copy"></i>
          URL কপি ({{ selectedImages.length }})
        </button>
        <button 
          type="button"
          class="btn-secondary-modern" 
          (click)="bulkDownload()">
          <i class="fas fa-download"></i>
          ডাউনলোড ({{ selectedImages.length }})
        </button>
        <button 
          type="button"
          class="btn-secondary-modern" 
          (click)="bulkDelete()">
          <i class="fas fa-trash"></i>
          ডিলিট ({{ selectedImages.length }})
        </button>
        <button 
          type="button"
          class="btn-outline-modern" 
          (click)="clearSelection()"
          [title]="getSelectionContext()">
          <i class="fas fa-times"></i>
          নির্বাচন সাফ করুন
        </button>
        <div class="selection-info bangla-text" *ngIf="selectedImages.length > 0">
          <i class="fas fa-info-circle"></i>
          {{ getSelectionContext() }}
        </div>
      </div>
    </div>
  </div>

  <!-- Gallery Data Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-images"></i>
        ইমেজ ডেটা
      </h3>
      <div class="card-actions">
        <span class="data-count bangla-text">
          মোট <strong>{{ filteredImages.length }}</strong> টি ইমেজ
        </span>
      </div>
    </div>
    
    <div class="card-body">
      <!-- Select All -->
      <div class="select-all-section" *ngIf="!isLoadingImages && allImages.length > 0">
        <div class="select-all-container">
          <label class="checkbox-container bangla-text">
            <input 
              type="checkbox" 
              [checked]="isAllSelected()" 
              [indeterminate]="isSomeSelected()"
              (change)="toggleSelectAll($event)">
            <span class="checkmark"></span>
            {{ getSelectAllText() }}
          </label>
        </div>
      </div>

      <!-- Gallery Content -->
        <!-- Loading State -->
      <div *ngIf="isLoadingImages" class="loading-state">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p class="bangla-text">ইমেজ লোড হচ্ছে...</p>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoadingImages && allImages.length === 0" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-image"></i>
        </div>
        <h3 class="bangla-title">কোন ইমেজ পাওয়া যায়নি</h3>
        <p class="bangla-text">এখনো কোন ইমেজ আপলোড করা হয়নি। উপরের ফর্ম ব্যবহার করে প্রথম ইমেজ আপলোড করুন।</p>
        <button type="button" class="btn-primary-modern bangla-text" (click)="scrollToUpload()">
          <i class="fas fa-upload"></i>
          ইমেজ আপলোড করুন
        </button>
      </div>

      <!-- No Search Results -->
      <div *ngIf="!isLoadingImages && allImages.length > 0 && filteredImages.length === 0" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-search"></i>
        </div>
        <h3 class="bangla-title">খোঁজার ফলাফল পাওয়া যায়নি</h3>
        <p class="bangla-text">আপনার খোঁজার সাথে মেলে এমন কোন ইমেজ পাওয়া যায়নি।</p>
        <button type="button" class="btn-secondary-modern bangla-text" (click)="clearSearch()">
          <i class="fas fa-redo"></i>
          খোঁজ পরিষ্কার করুন
        </button>
      </div>

      <!-- Grid View -->
      <div class="image-grid" *ngIf="!isLoadingImages && filteredImages.length > 0 && galleryView === 'grid'">
        <div class="image-card" *ngFor="let image of paginatedImages; trackBy: trackByImageUrl; let i = index">
          <div class="image-container" [class.selected]="isImageSelected(image)">
            <!-- Selection Checkbox -->
            <div class="image-select">
              <label class="checkbox-container">
                <input 
                  type="checkbox" 
                  [checked]="isImageSelected(image)"
                  (change)="toggleImageSelection(image, $event)">
                <span class="checkmark"></span>
              </label>
            </div>

            <!-- Image -->
            <img 
              [src]="image" 
              [alt]="getImageName(image)" 
              class="gallery-image" 
              (load)="onImageLoad($event)"
              (error)="onImageError($event)">
            
            <!-- Loading indicator -->
            <div class="image-loading" *ngIf="!isImageLoaded(image)">
              <i class="fas fa-spinner fa-spin"></i>
            </div>

            <!-- Image Overlay -->
            <div class="image-overlay">
              <div class="image-actions">
                <button 
                  type="button"
                  class="btn-action-overlay view" 
                  (click)="viewImage(image)" 
                  title="পূর্ণ আকারে দেখুন">
                  <i class="fas fa-eye"></i>
                </button>
                <button 
                  type="button"
                  class="btn-action-overlay copy" 
                  (click)="copyImageUrl(image)" 
                  title="URL কপি করুন">
                  <i class="fas fa-copy"></i>
                </button>
                <a 
                  [href]="image" 
                  [download]="getImageName(image)"
                  class="btn-action-overlay download" 
                  title="ডাউনলোড করুন">
                  <i class="fas fa-download"></i>
                </a>
                <button 
                  type="button"
                  class="btn-action-overlay delete" 
                  (click)="deleteImage(image)" 
                  title="ইমেজ ডিলিট করুন">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              
              <!-- Image Info Overlay -->
              <div class="image-info-overlay">
                <div class="image-details">
                  <span class="image-format">{{ getImageFormat(image) }}</span>
                  <span class="image-dimensions" *ngIf="getImageDimensions(image) !== 'Original Size'">
                    {{ getImageDimensions(image) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Image Info -->
          <div class="image-info">
            <h6 class="image-name bangla-text" [title]="getImageName(image)">
              {{ getImageName(image) }}
            </h6>
            <div class="image-meta">
              <span class="image-format-badge">{{ getImageFormat(image) }}</span>
              <span class="image-size" *ngIf="getImageFileSize(image)">
                {{ getImageFileSize(image) }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- List View -->
      <div class="image-list" *ngIf="!isLoadingImages && filteredImages.length > 0 && galleryView === 'list'">
        <div class="list-item" [class.selected]="isImageSelected(image)" *ngFor="let image of paginatedImages; trackBy: trackByImageUrl">
          <div class="list-item-content">
            <!-- Selection -->
            <div class="list-select">
              <label class="checkbox-container">
                <input 
                  type="checkbox" 
                  [checked]="isImageSelected(image)"
                  (change)="toggleImageSelection(image, $event)">
                <span class="checkmark"></span>
              </label>
            </div>

            <!-- Thumbnail -->
            <div class="list-thumbnail">
              <img [src]="image" [alt]="getImageName(image)" class="list-image">
            </div>

            <!-- Details -->
            <div class="list-details">
              <h6 class="list-name bangla-text">{{ getImageName(image) }}</h6>
              <div class="list-meta">
                <span class="meta-item">
                  <i class="fas fa-tag"></i>
                  {{ getImageFormat(image) }}
                </span>
                <span class="meta-item" *ngIf="getImageFileSize(image)">
                  <i class="fas fa-weight-hanging"></i>
                  {{ getImageFileSize(image) }}
                </span>
                <span class="meta-item">
                  <i class="fas fa-expand-arrows-alt"></i>
                  {{ getImageDimensions(image) }}
                </span>
              </div>
            </div>

            <!-- Actions -->
            <div class="list-actions">
              <button 
                type="button"
                class="btn-action-sm view" 
                (click)="viewImage(image)" 
                title="পূর্ণ আকারে দেখুন">
                <i class="fas fa-eye"></i>
              </button>
              <button 
                type="button"
                class="btn-action-sm copy" 
                (click)="copyImageUrl(image)" 
                title="URL কপি করুন">
                <i class="fas fa-copy"></i>
              </button>
              <a 
                [href]="image" 
                [download]="getImageName(image)"
                class="btn-action-sm download" 
                title="ডাউনলোড করুন">
                <i class="fas fa-download"></i>
              </a>
              <button 
                type="button"
                class="btn-action-sm delete" 
                (click)="deleteImage(image)" 
                title="ইমেজ ডিলিট করুন">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination-container" *ngIf="!isLoadingImages && filteredImages.length > imagesPerPage">
        <div class="pagination-info bangla-text">
          <span>
            {{ getPaginationInfo() }}
          </span>
        </div>
        <div class="pagination-controls">
          <button 
            type="button"
            class="pagination-btn" 
            [disabled]="currentPage === 1"
            (click)="goToPage(currentPage - 1)"
            title="পূর্ববর্তী পাতা">
            <i class="fas fa-chevron-left"></i>
          </button>
          
          <span class="page-numbers">
            <button 
              type="button"
              class="page-number" 
              *ngFor="let page of getPageNumbers()"
              [class.active]="page === currentPage"
              [class.dots]="page === '...'"
              [disabled]="page === '...'"
              (click)="goToPage(page)">
              {{ page }}
            </button>
          </span>
          
          <button 
            type="button"
            class="pagination-btn" 
            [disabled]="currentPage === totalPages"
            (click)="goToPage(currentPage + 1)"
            title="পরবর্তী পাতা">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Image Viewer Modal -->
  <div class="image-viewer-modal" *ngIf="viewingImage" (click)="closeImageViewer()">
    <div class="viewer-content" (click)="$event.stopPropagation()">
      <div class="viewer-header">
        <h4 class="bangla-text">{{ getImageName(viewingImage) }}</h4>
        <button type="button" class="btn-action-sm" (click)="closeImageViewer()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="viewer-body">
        <img [src]="viewingImage" [alt]="getImageName(viewingImage)" class="viewer-image">
      </div>
      <div class="viewer-actions">
        <button type="button" class="btn-secondary-modern bangla-text" (click)="copyImageUrl(viewingImage)">
          <i class="fas fa-copy"></i>
          URL কপি করুন
        </button>
        <a [href]="viewingImage" target="_blank" class="btn-primary-modern bangla-text">
          <i class="fas fa-external-link-alt"></i>
          নতুন ট্যাবে খুলুন
        </a>
      </div>
    </div>
  </div>

  <!-- Toast Notifications -->
  <div class="toast-container" *ngIf="toastMessage">
    <div class="toast-card" [class]="toastType">
      <div class="toast-content">
        <i class="fas" [class]="getToastIcon()"></i>
        <span class="bangla-text">{{ toastMessage }}</span>
      </div>
      <button type="button" class="toast-close" (click)="closeToast()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</div>
